<template>
  <sui-page>
    <sui-page-header :pageId="contextPageId" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_PORTL')" />
          </div>
          <div class="col-xs-5">
            <sui-custom-select
              ref="customSelectPortalId"
              :selected="queryData.portalId"
              :option-list="portalList"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_BSIC_ISTL_YN')" />
          </div>
          <div class="col-xs-5">
            <sui-yn-select
              ref="ynSelectBasicsInstallationYn"
              v-model="queryData.basicsInstallationYn"
              :defaultOption="'all'"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_DEL_YN')" />
          </div>
          <div class="col-xs-5">
            <sui-yn-select
              ref="ynSelectDeleteYn"
              v-model="queryData.deleteYn"
              :defaultOption="'all'"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_SEARCH_COND')" />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="codeSelectSearchCondition"
              v-model="queryData.searchCondition"
              codeId="COD_APP_SEARCH_COND"
              :defaultOption="'all'"
            />
            <div class="comp_spacing" />
            <sui-text-field
              v-model="queryData.searchText"
              maxlength="100"
              @keyup.enter="onClickSearch"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onClickReset"
          >
            {{ $t("MSG_BTN_RESET") }}
          </sui-button>
          <sui-button
            v-permission:read="contextPageId"
            type="button"
            class="comm_btn_Scr"
            @click="onClickSearch"
          >
            {{ $t("MSG_BTN_SRCH") }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <ur-data-grid
        ref="gridMobileAppMgt"
        :headers="columnMobileAppMgt"
        :data-source="dsMobileAppMgt"
        :options="options"
        @grid:row-click="onSelectRow"
      >
        <template #left-info>
          <ur-dropdown
            class="ur-data-grid__info__per-page"
            :items="perPageItems"
            v-model="rowsPerPage"
            @input="onChangePageSize"
          />
          <ur-button sm
            @click="onClickReordering"
          >
            {{ $t('MSG_TXT_RE_ORDER') }}
          </ur-button>
        </template>
        <template #right-info>
          <sui-button
            class="comm_btn_gridTop comm_ico_excel"
            @click="onClickExcelDownload"
          >
            {{ $t('MSG_BTN_EXCEL_DOWN') }}
          </sui-button>          
        </template>
      </ur-data-grid>
      <div class="mrB30" />
      <sui-page-tab-box-type
        ref="tab"
        :tabItems="tabItems"
        :defaultTabIndex="defaultTabIndex"
        :setCurrentTabComponent="onSetCurrentTabComponent"
        @change-tab-idx="onChangeTabIdx"
      >
        <container
          :is="currentTabComponent"
          :selectedGridRowData="selectedGridRowData"
          @onClickSearch="onClickSearch"
        />
      </sui-page-tab-box-type>
      <sui-popup
        v-model="showPopup"
        :title="popTitle"
      >
        <p01
          :pageId="contextPageId"
          :portalId="queryData.portalId.key"
          @app-reorder-cancel="onPopupCancel"
          @app-reorder-save="onPopupSave"
        />
      </sui-popup>
    </sui-page-contents>
  </sui-page>
</template>

<script>
import BasePage from '~cm/components/BasePage';
import {urDataSet} from 'uidev-component/index.js';
import tab01 from './components/PGE_CMP_00026_T01.vue';
import tab02 from './components/PGE_CMP_00026_T02.vue';
import p01 from './components/PGE_CMP_00026_P01';
import urDataGrid from '@uidev/grid/urDataGrid/urDataGrid';

const DEFAULT_ROWS_PER_PAGE = 5;
const DEFAULT_ROW_HEIGHT = 55;

export default {
  name: 'PGE_CMP_00026', // eslint-disable-line vue/name-property-casing
  components: {
    tab01,
    tab02,
    p01,
    urDataGrid,
  }, 
  extends: BasePage,
  data() {
    return {
      dsMobileAppMgt: new urDataSet(),
      options: {
        infinityScroll: true,
        noBaseInfo: false,
        internalPaging: false,
        height: DEFAULT_ROWS_PER_PAGE * DEFAULT_ROW_HEIGHT,
      },
      rowsPerPage: DEFAULT_ROWS_PER_PAGE,
      selectedGridRowData: {},
      tabItems: [
        {
          tabTitle: this.$t('MSG_TXT_APPLICATION'),
          component: tab01,
        },
        {
          tabTitle: this.$t('MSG_TXT_ROLE'),
          component: tab02,
        },
      ],
      currentTabComponent: 'tab01',
      defaultTabIndex: 0,
      queryData: {
        portalId: {},
        basicsInstallationYn: '',
        deleteYn: '',
        searchCondition: '',
        searchText: '',
      },
      portalList: [],
      popTitle: this.$t('MSG_TXT_RE_ORDER'),
      showPopup: false,
    };
  },
  computed: {
  },
  watch: {},
  created() {
    this.perPageItems = [
      { value: 5, text: '5 per page' },
      { value: 10, text: '10 per page' },
      { value: 15, text: '15 per page' },
    ];
    this.columnMobileAppMgt = [
      {
        value: 'portalId',
        text: this.$t('MSG_TXT_PORTL'),
        width: 200,
      },
      {
        value: 'applicationId',
        text: this.$t('MSG_TXT_APPLICATION_ID'),
        width: 200,
      },
      {
        value: 'applicationName',
        text: this.$t('MSG_TXT_APPLICATION_NM'),
      },
      {
        value: 'basicsInstallationYn',
        text: this.$t('MSG_TXT_BSIC_ISTL_YN'),
        width: 100,
      },
      {
        value: 'deleteYn',
        text: this.$t('MSG_TXT_DEL_YN'),
        width: 80,
      },
      {
        value: 'finalModificationUserName',
        text: this.$t('MSG_TXT_MDFC_USR'),
        component: {
          props: ['row', 'value'],
          template:
            `<cmp-user-name-link
              :pageId="'PGE_CMP_00026'"
              :displayType="'1'"
              :displayLanguageId="row.finalModificationDisplayLangId"
              :userId="row.finalModificationUserId"
              :loginId="row.finalModificationLoginId"
              :userName="row.finalModificationUserName"
              :userGlobalName="row.finalModificationUserGlobalName"
              :departmentName="row.finalModificationDepartmentName"
              :departmentEnglishName="row.finalModificationDepartmentEnglishName"
              :type="'link'"
            />`
        },
        width: 200,
      },
      {
        value: 'finalModificationDTM',
        text: this.$t('MSG_TXT_MDFC_DTM'),
        customValue: function(value, row) {
          return utils.dateformatToClient(value)
        },
        width: 150,
      },
    ];    
  },
  beforeMount() {
    this.onLoadPortalList();
  },
  mounted() {
    this.$nextTick(() => {
      this.onLoad();
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onLoadPortalList() {
      http.request(this.contextPageId, 'DTS_CMP_00004')
      .then(res => {
        utils.forEach(res.data, obj => {
          this.portalList.push({
            key: obj.portalId,
            label: obj.portalName,
          });
        });
      }).catch(error => {
        console.log(error);
      });
    },
    onLoad() {
      const paramData = utils.getParameter(this, 'queryData');
      if (!utils.isEmpty(paramData)) {
        this.queryData = paramData;
        this.onClickSearch();
      }
    },
    onClickSearch() {
      const dataParams = {
        portalId: this.queryData.portalId.key,
        basicsInstallationYn: this.queryData.basicsInstallationYn,
        deleteYn: this.queryData.deleteYn,
        searchCondition: this.queryData.searchCondition,
        searchText: this.queryData.searchText,
      };
      http.request(this.contextPageId, 'DTS_CMP_00116', {
        query: dataParams,
      }).then(res => {
        this.dsMobileAppMgt.setData(res.data);
      });
    },
    onClickReset() {
      this.$refs.customSelectPortalId.reset();
      this.$refs.ynSelectBasicsInstallationYn.reset();
      this.$refs.ynSelectDeleteYn.reset();
      this.$refs.codeSelectSearchCondition.reset();
      this.queryData.searchText = '';
    },
    onSetCurrentTabComponent(component) {
      this.currentTabComponent = component;
    },
    onChangeTabIdx(idx) {
      this.currentTabComponent = this.tabItems[idx].component;
    },
    onClickExcelDownload() {
      const sPageId = this.contextPageId;
      const objGridColumns = this.columnMobileAppMgt;
      const objGridDataset = this.dsMobileAppMgt;
      const sToday = utils.now('YYYYMMDDHHmmss');
      const sExcelName = `mobile_application_management_${sToday}.xlsx`;
      utils.downloadGridToExcel(sPageId, objGridColumns, objGridDataset, sExcelName, {});
    },
    onSelectRow(row) {
      if(row) {
        this.selectedGridRowData = row;
      }
    },
    onChangePageSize(v) {
      this.$refs.gridMobileAppMgt.mx_pager.rowsPerPage = v;
      this.options.height =  v * DEFAULT_ROW_HEIGHT;
      this.$nextTick(() => {
        this.$refs.gridMobileAppMgt.mx_buildViewData();
      });
    },
    onClickReordering() {
      this.showPopup = true;
    },
    onPopupCancel() {
      this.showPopup = false;
    },
    onPopupSave() {
      this.showPopup = false;
      this.onClickSearch();
    },
  },
};
</script>

<style scoped>
</style>
